/* globals gon */

import 'packery/dist/packery.pkgd'
import FontFaceOnload from 'fontfaceonload'

window['portal/job_ads#index'] = function () {
  postMessageHeight()
  observeHeightForIframeResize()

  if (window.location.search.match('query')) {
    const element = $('.page-container')
    element.length &&
      $('html, body').animate({ scrollTop: element.offset().top - 65 }, 10)
  }

  const fontFamily = gon.application.career_site_settings.font.fontFamily?.replace(/"/g, '')
  const initPackery = function () {
    $('.packery-grid').packery({ itemSelector: '.job-ad-block-container' })
    $('.packery-grid .job-ad-block-container').each(function () {
      setTimeout(() => { $(this).animate({ opacity: 1 }, 150) }, Math.random() * 300)
    })
    $('.packery-grid').packery('layout')
    $('.packery-grid').on('layoutComplete', () => postMessageHeight())
  }

  if (fontFamily && gon.application.career_site_settings.font.font_face) {
    FontFaceOnload(fontFamily, {
      success: initPackery,
      error: initPackery,
      timeout: 500
    })
  } else {
    setTimeout(initPackery, 500)
  }

  $(document).on('change', 'form.job-ads-filters', function (e) {
    // $(this).trigger('submit');
    postMessageHeight(0)
  })

  $('.job-location').on('click', function (e) {
    const latitude = $(e.target).data('latitude')
    const longitude = $(e.target).data('longitude')
    const map = window.jobAdsMap

    if (latitude && longitude && map) {
      e.preventDefault()

      $('html, body').animate({
        scrollTop: $('.map-container').offset().top - 100
      }, 600, 'linear', () => {
        map.panTo({ lat: latitude, lng: longitude })
        map.setZoom(10)
      })
    }
  })

  // Video sound toggle
  $('#sound-switcher').on('click', function () {
    const soundOn = $(this).hasClass('on')
    $('#sound-switcher').toggleClass('on', !soundOn)
    $('#video').prop('muted', soundOn)
  })
}

window['portal/job_ads#show'] = function () {
  postMessageHeight()
  observeHeightForIframeResize()

  $('.copy2clipboard').on('click', function (event) {
    event.preventDefault()
    const link = $(this).data('link')
    const temp = $('<input>')
    $('body').append(temp)
    temp.val(link).select()
    document.execCommand('copy')
    temp.remove()
    $(this)[0].childNodes[1].nodeValue = I18n.t('job_ad.copied')
    setTimeout(function () { $('.copy2clipboard')[0].childNodes[1].nodeValue = I18n.t('job_ad.copy_link') }, 3000)
  })

  if ($('#carousel_job_ad_images ol li').length > 1) {
    $('#carousel_job_ad_images .carousel-control').removeClass('hidden')
  } else {
    $('#carousel_job_ad_images .carousel-control').addClass('hidden')
  }

  $(document).on('click', '.share-links a:not(.share-envelope)', function (e) {
    e.preventDefault()
    window.open(this.href, '.share-links a:not(.share-envelope)', 'width=800,height=400,resizable=yes,scrollbars=yes')
  })
}

// The map/filters section (and any other async widget - fonts, images, Google Maps'
// own script) can settle its final height well after the one-off postMessageHeight()
// calls around packery/font loading already fired, and a plain ResizeObserver on body
// isn't reliable here in practice. Poll for a few seconds instead: cheap, and it
// guarantees the embedding iframe converges on the real height regardless of which
// async widget was still resizing things after our explicit trigger points fired.
let iframeResizeObserverActive = false

function observeHeightForIframeResize () {
  if (window.self === window.top) return
  if (iframeResizeObserverActive) return
  iframeResizeObserverActive = true

  const pollUntil = Date.now() + 5000
  let lastHeight = null

  const poll = () => {
    const height = document.body.offsetHeight
    if (height !== lastHeight) {
      lastHeight = height
      postMessageHeight(height)
    }
    if (Date.now() < pollUntil) {
      setTimeout(poll, 250)
    } else {
      iframeResizeObserverActive = false
    }
  }

  poll()
}

function postMessageHeight (height) {
  if (window.self === window.top) return
  if (height === undefined) height = document.body.offsetHeight
  window.parent.postMessage({
    height
  }, '*')
}
